import {
  getUserSettings,
  setUserSetting,
} from '../../utils/userSettings/index.js'
import { PickerIcon } from '../types.js'

const FREQUENTLY_USED_KEY = 'iconPickerFrequently'
const LAST_USED_KEY = 'iconPickerLast'

export function addFrequentlyUsedIcon(icon: PickerIcon) {
  const index = getUserSettings().iconPickerFrequently || {}

  const iconName = icon.name
  if (!iconName) {
    return
  }

  const newValue = (index[iconName] ?? 0) + 1

  setUserSetting(LAST_USED_KEY, iconName)
  setUserSetting(FREQUENTLY_USED_KEY, {
    ...index,
    [iconName]: newValue,
  })
}

export function getFrequentlyUsedIcons() {
  const maxFrequentRows = 4
  const perLine = 9
  const index = getUserSettings().iconPickerFrequently || {}

  if (!index) {
    return []
  }

  const iconNames = Object.keys(index)

  const max = maxFrequentRows * perLine
  const last: string = getUserSettings().iconPickerLast ?? ''

  iconNames.sort((a: string, b: string) => {
    const aScore = index[b]
    const bScore = index[a]

    if (aScore === bScore) {
      return a.localeCompare(b)
    }

    return aScore - bScore
  })

  if (iconNames.length <= max) {
    return iconNames
  }

  const removedIds = iconNames.slice(max)

  const iconNameReplacedWithLast =
    last && !iconNames.includes(last)
      ? iconNames[iconNames.length - 1]
      : undefined

  const cleanedIndex = Object.fromEntries(
    Object.entries(index).filter(
      ([key]) => !removedIds.includes(key) && key !== iconNameReplacedWithLast,
    ),
  )
  const updatedIndex = iconNameReplacedWithLast
    ? { ...cleanedIndex, [last]: 1 }
    : cleanedIndex

  setUserSetting(FREQUENTLY_USED_KEY, updatedIndex)
  return Object.keys(updatedIndex)
}
